import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../theme/scalingTokens';

export const useWelcomeSectionStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('1rem'),
    boxShadow: tokens.shadow8,
    ...shorthands.padding('3rem'),
    ...shorthands.gap('1rem'),
    width: '100%',
    boxSizing: 'border-box',
    [mq.mobile]: {
      ...shorthands.padding('1.5rem'),
    },
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '4rem',
    height: '4rem',
    color: tokens.colorBrandForeground2,
  },

  title: {
    fontWeight: 700,
    fontSize: fontScale.subtitle,
    lineHeight: '1.375em',
    textAlign: 'center' as const,
    color: tokens.colorNeutralForeground1,
    margin: '0',
  },

  description: {
    fontWeight: 400,
    fontSize: fontScale.body,
    lineHeight: '1.43em',
    textAlign: 'center' as const,
    color: tokens.colorNeutralForeground1,
    maxWidth: '35.75rem',
    margin: '0',
  },

  dividerWrapper: {
    maxWidth: '44rem',
    width: '100%',
  },

  sectionLabel: {
    fontWeight: 400,
    fontSize: fontScale.body,
    lineHeight: '1.43em',
    textAlign: 'center' as const,
    color: tokens.colorNeutralForeground1,
    margin: '0',
  },

  cardsRow: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap('2rem'),
    flexWrap: 'wrap',
    justifyContent: 'center',
    [mq.mobile]: {
      ...shorthands.gap('1rem'),
    },
  },
  bookButton: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
});
